import script from "./kalio-internal-batch-dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-internal-batch-dashboard.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__